import { useAppDispatch, useAppSelector } from '@/Hook/hooks';
import { getHomeUserSpecificData } from '@/Redux/Ducks/homeSlice';
import { getNotification, getUserInboxInformation } from '@/Redux/Ducks/inboxSlice';
import { getUserSpecificDetail } from '@/Redux/Ducks/userSlice';
import { getLayout } from '@/Utils/auth';
import { useEffect } from 'react';
import { AlignUIRender } from './indexUI';

const Authorize = (props: any) => {

  const dispatch = useAppDispatch();

  const sideBarState = useAppSelector((state) => state.Home.sideBarState);
  const authTokenLoaded = useAppSelector((state) => state.User.authToken);

  useEffect(() => {
    if (!authTokenLoaded)
      dispatch(getUserSpecificDetail());

    // dispatch(getUserInboxInformation());

    // init();

    if (getLayout()?.isEqual("RTL")) {
      document.documentElement.setAttribute("dir", "rtl");
    }
  }, []);

  return AlignUIRender({ ...props, sideBarState });

}

export default Authorize;

